// extracted by mini-css-extract-plugin
module.exports = {"container":"_1891198a","header":"_ccb61a52","subheader":"_6fd37dd6","icon":"_c74e6246","link":"_17fd58ad"};